export const environment = {
  production: false,
  // apiBaseUrl: '__API_BASE_URL__',
  apiBaseUrl: 'https://api.dev-biodiv-sniffer.dir.istefr.fr',
  cognitoUserPoolId: 'eu-west-3_DcjyY4Pto',
  cognitoAppClientId: '414hbovf4am0occtgrspqg7u29',
};
